export default __webpack_public_path__ + "static/ryan-acf1832d5ab24b039a40f74ac986edaf.jpeg";